import Template from "../../../../model2/template/template";
import {dashboardTemplatesProject} from "./goodday/templates-project";
import {PopoverMenuItemType} from "../../../../gd-components/popover-menu/popover-menu/const";

export default function projectDashboardTemplateOptions ():Options {


    const templatesOptions: Options   = []

    templatesOptions.push({
        label: "Empty",
        value: "project-empty"
    })

    templatesOptions.push({
        type    : PopoverMenuItemType.SEPARATOR
    })


    if (gd.session.templates.projectDashboards.length > 0) {

        // looks bad - zdem kogda normal'no sdelaut header
        // templatesOptions.push({
        //     type    : PopoverMenuItemType.HEADER,
        //     title   : 'My Templates'
        // })

        // Add public / private templates
        _.map(gd.session.templates.projectDashboards, (template: Template) => {
            templatesOptions.push({
                label: template.name,
                value: template.id
            })
        })

        templatesOptions.push({
            type    : PopoverMenuItemType.SEPARATOR
        })

    }



    // Goodday templates
    _.map(dashboardTemplatesProject, template => {

        if (template.templateId === "project-empty") {
            return
        }

        templatesOptions.push({
            label: template.name,
            value: template.templateId
        })

    })

    return templatesOptions


}